import { AxiosInstance } from 'axios';
import DealershipsService from './dealershipsService';

export default function useProfile( axiosIns: AxiosInstance, dealershipsOverrideConfig: Object ) {
  const profile = new DealershipsService( axiosIns, dealershipsOverrideConfig );

  return {
    profile,
  }
}